var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLikeTable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    rx: 10,
    fill: "#FEF2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.19922 10.3002C9.19922 9.80314 9.60216 9.40019 10.0992 9.40019C10.5963 9.40019 10.9992 9.80314 10.9992 10.3002V13.9002C10.9992 14.3973 10.5963 14.8002 10.0992 14.8002C9.60216 14.8002 9.19922 14.3973 9.19922 13.9002V10.3002Z",
    stroke: "#1870c7",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5992 10.2002V13.4586C11.5992 13.9131 11.856 14.3286 12.2626 14.5319L12.2925 14.5468C12.6257 14.7134 12.9932 14.8002 13.3658 14.8002H16.6155C17.1875 14.8002 17.68 14.3964 17.7921 13.8355L18.5121 10.2355C18.6607 9.49298 18.0927 8.80019 17.3355 8.80019H15.1992V6.4002C15.1992 5.73745 14.662 5.2002 13.9992 5.2002C13.6678 5.2002 13.3992 5.46882 13.3992 5.8002V6.2002C13.3992 6.71948 13.2308 7.22476 12.9192 7.64019L12.0792 8.76019C11.7676 9.17563 11.5992 9.68091 11.5992 10.2002Z",
    stroke: "#1870c7",
    strokeWidth: 1.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeTable);
export default __webpack_public_path__ + "static/media/LikeTable.897619608e8daf50534c904acfa4250a.svg";
export { ForwardRef as ReactComponent };